<template>
  <div class="product-status">
    <div
      v-if="canSee"
      class="product-status__grid"
    >
      <button
        v-for="row in rows"
        :key="row.key"
        type="button"
        class="product-status__tile"
        :class="'product-status__tile--' + row.key"
        @click="go(row.to)"
      >
        <span class="product-status__top">
          <span class="product-status__icon">
            <v-icon size="16" :color="row.iconColor">{{ row.icon }}</v-icon>
          </span>
          <span class="product-status__name">{{ row.title }}</span>
        </span>
        <span class="product-status__desc">{{ row.desc }}</span>
        <span class="product-status__value">
          {{ $numberFormat(row.value) }}
          <span class="product-status__unit">{{ row.unit }}</span>
        </span>
      </button>
    </div>
    <div
      v-else
      class="product-status__empty"
    >
      {{ $t("you don't have access to this information") }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeProductStatus',
  props: {
    popular: {
      type: Number,
      default: 0
    },
    stagnant: {
      type: Number,
      default: 0
    }
  },
  computed: {
    canSee () {
      return this.$store.getters.getpermission && this.$store.getters.getpermission.includes('overview')
    },
    rows () {
      return [
        {
          key: 'popular',
          title: this.$t('popular-product'),
          desc: this.$t('products that make up more than 50% of your sales.'),
          value: this.popular,
          unit: this.$t('product'),
          icon: 'mdi-fire',
          iconColor: '#00A63E',
          to: 'ProductList'
        },
        {
          key: 'stagnant',
          title: this.$t('stagnant-products'),
          desc: this.$t('products that have not been sold for a while.'),
          value: this.stagnant,
          unit: this.$t('product'),
          icon: 'mdi-package-variant-closed',
          iconColor: '#6B7280',
          to: 'ProductList'
        }
      ]
    }
  },
  methods: {
    go (name) {
      this.$router.push({ name: name }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.product-status {
  width: 100%;
  height: 159px;
  background: transparent;
  overflow: hidden;
}
.product-status__grid {
  height: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr;
  gap: 12px;
}
.product-status__tile {
  min-width: 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  text-align: start;
  padding: 12px;
  border: 1px solid #E5E7EB;
  background: #fff;
  border-radius: 4px;
  cursor: pointer;
  color: #111;
}
.product-status__tile--popular {
  background: #F6FBF7;
  border-color: #E3F0E7;
}
.product-status__tile--stagnant {
  background: #F7F7F8;
  border-color: #E8E8EA;
}
.product-status__top {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}
.product-status__icon {
  width: 28px;
  height: 28px;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
}
.product-status__tile--popular .product-status__icon {
  background: #E8F8EF;
}
.product-status__tile--stagnant .product-status__icon {
  background: #F3F4F6;
}
.product-status__name {
  font-size: 13px;
  font-weight: 700;
  color: #111;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.product-status__desc {
  margin-top: 8px;
  font-size: 11px;
  line-height: 1.5;
  color: #6B7280;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.product-status__value {
  margin-top: auto;
  display: flex;
  align-items: baseline;
  justify-content: flex-end;
  gap: 4px;
  font-size: 14px;
  font-weight: 700;
  color: #111;
  line-height: 1.4;
}
.product-status__tile--popular .product-status__value {
  color: #00A63E;
}
.product-status__unit {
  font-size: 11px;
  font-weight: 500;
  color: #6B7280;
}
.product-status__empty {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: #6B7280;
  text-align: center;
  background: #fff;
  border: 1px solid #E5E7EB;
  border-radius: 4px;
}
</style>
